import { render, staticRenderFns } from "./external-link.vue?vue&type=template&id=99773e12&"
import script from "./external-link.vue?vue&type=script&lang=ts&"
export * from "./external-link.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports